import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const tabsContainer: SxStyle = {
  height: 'fit-content',
};
